/**
 * 设备报警模拟数据 — 字段对齐 device_alarm_records / DeviceAlarmRecordsEntity；device 对齐 BaseDeviceManageEntity（看板接口嵌套返回）
 * 正式对接接口后可移除此工具，由后端返回列表。
 */
export const STATUS_LABEL = { 0: '待确认', 1: '处理中', 2: '已处理', 4: '已关闭' }
export const MECH_LABEL = { 1: '微信通知', 2: '弹窗提醒', 3: '大屏展示' }
export const TYPES = ['设备故障', '安全隐患', '检修', '其他']
export const CATEGORIES = ['机电', '电气', '配件']
export const LEVELS = ['一级', '二级', '三级']

const DEVICES = [
  { name: '1# 斗轮机', type: '堆取料机' },
  { name: '2# 皮带机', type: '输送设备' },
  { name: '3# 变压器', type: '变电设备' },
  { name: '煤流采样器 A', type: '采样设备' },
  { name: '除尘风机 B', type: '环保设备' },
  { name: '液压站 C', type: '液压系统' },
  { name: '翻车机', type: '卸车设备' },
  { name: '推料机', type: '辅助设备' },
  { name: '照明配电箱', type: '电气' },
  { name: 'PLC 控制柜', type: '自控' }
]

function pad(n) {
  return n < 10 ? '0' + n : String(n)
}

/** @returns {number} ms */
export function createMockAlarmRecords(count, options = {}) {
  const { longTailDays = 45, randomDevice = false } = options
  const list = []
  for (let i = 0; i < count; i++) {
    const daysAgo = Math.floor(Math.pow(Math.random(), 1.15) * longTailDays)
    const h = Math.floor(Math.random() * 24)
    const m = Math.floor(Math.random() * 60)
    const d = new Date()
    d.setHours(h, m, 0, 0)
    d.setDate(d.getDate() - daysAgo)
    const t = d.getTime()
    const cat = CATEGORIES[i % CATEGORIES.length]
    const alertType = LEVELS[Math.min(2, Math.floor(Math.random() * 4))]
    const type = TYPES[Math.floor(Math.random() * TYPES.length)]
    const statusRoll = Math.random()
    const alertStatus = statusRoll < 0.14 ? 0 : statusRoll < 0.32 ? 1 : statusRoll < 0.62 ? 2 : 4
    const cur = Number((Math.random() * 100).toFixed(1))
    const th = Number((Math.random() * 80 + 20).toFixed(1))
    const dev = randomDevice ? DEVICES[Math.floor(Math.random() * DEVICES.length)] : DEVICES[i % DEVICES.length]
    const contractSeq = 1000 + i * 17 + (i % 9000)
    const deviceId = 200 + (i % 6)
    list.push({
      id: 100000 + i,
      deviceId,
      category: cat,
      deviceType: dev.type,
      deviceName: dev.name,
      alertType,
      type,
      handlingMechanism: Math.floor(Math.random() * 3) + 1,
      currentValue: cur,
      thresholdValue: th,
      parameterKey: ['temperature', 'vibration', 'current', 'pressure'][i % 4],
      alertTime: t,
      alertStatus,
      alarmContent: `${type}：${dev.name} ${['超限', '异常波动', '通讯中断', '维护到期'][i % 4]}`,
      processorName: alertStatus >= 2 ? ['张三', '李四', '王五'][i % 3] : '',
      processTime: alertStatus >= 2 ? t + (30 + Math.random() * 360) * 60000 : null,
      processResult: alertStatus === 4 ? '已闭环' : alertStatus === 2 ? '现场已处置' : '',
      contractNo: 'HT-NX-2026-' + String(contractSeq).padStart(4, '0'),
      contractName: '设备维保框架协议（模拟）',
      device: {
        id: deviceId,
        deviceName: dev.name,
        deviceLocation: ['一期煤棚', '圆形料场', '集控楼二层'][i % 3] + ' #' + pad((i % 5) + 1),
        longitude: 106.512 + (Math.random() * 0.008),
        latitude: 38.912 + (Math.random() * 0.006),
        areaCode: 'AREA-0' + ((i % 3) + 1),
        areaName: ['北区', '中区', '南区'][i % 3]
      }
    })
  }
  return list.sort((a, b) => b.alertTime - a.alertTime)
}
